module.exports = __webpack_public_path__ + "static/media/shoprite-card.eb1dd852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shoprite-card.png
// module id = 350
// module chunks = 0